/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { PitrBackupResourceType } from '../models/PitrBackupResourceType';
import { PitrBackupSchedules } from '../models/PitrBackupSchedules';
import { StandardBackupSchedules } from '../models/StandardBackupSchedules';

export class PitrBackupPolicyPlan {
  'resourceType': PitrBackupResourceType;
  /**
  * List of backup schedules. Each schedule specifies a backup frequency, retention period, and vault. 
  */
  'backupSchedules': Array<StandardBackupSchedules>;
  /**
  * List of PiTR backup schedules. Each schedule specifies a backup frequency, retention period, and vault. 
  */
  'pitrSchedules'?: Array<PitrBackupSchedules>;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "resourceType",
      "baseName": "resourceType",
      "type": "PitrBackupResourceType",
      "format": ""
    },
    {
      "name": "backupSchedules",
      "baseName": "backupSchedules",
      "type": "Array<StandardBackupSchedules>",
      "format": ""
    },
    {
      "name": "pitrSchedules",
      "baseName": "pitrSchedules",
      "type": "Array<PitrBackupSchedules>",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return PitrBackupPolicyPlan.attributeTypeMap;
  }

  public constructor() {
  }
}

